import { ClothIcon } from "@components/icons/cloth";
import { HaircutIcon } from "@components/icons/haircut";
import {
  ArrowPathRoundedSquareIcon,
  PencilSquareIcon,
  Square3Stack3DIcon,
} from "@heroicons/react/16/solid";
import { ImageIcon } from "@radix-ui/react-icons";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

export type CameraModeType = "classic" | "pack" | "image" | "tryon" | "haircut";

export const useCameraModes = () => {
  const { t } = useTranslation();
  const { site } = useParams<{ site: string }>();

  const modes: {
    [key in CameraModeType]: {
      label: string;
      icon: React.ComponentType<{ className?: string }>;
    };
  } = {
    classic: {
      label: t("camera.form.modes.classic"),
      icon: PencilSquareIcon,
    },
    image: {
      label: t("camera.form.modes.image"),
      icon: ImageIcon,
    },
    ...(site === "portraits"
      ? ({
          pack: {
            label: t("camera.form.modes.pack"),
            icon: Square3Stack3DIcon,
          },
          tryon: {
            label: t("camera.form.modes.tryon"),
            icon: ClothIcon,
          },
          haircut: {
            label: t("camera.form.modes.haircut"),
            icon: HaircutIcon,
          },
        } as any)
      : {}),
  };

  return { modes };
};

export const useImageTransformModes = () => {
  const { t } = useTranslation();

  return {
    reimagine: {
      label: t("camera.form.modes.reimagine"),
      icon: ImageIcon,
      similarity: 20,
    },
    faceswap: {
      label: t("camera.form.modes.faceswap"),
      icon: ArrowPathRoundedSquareIcon,
      similarity: 100,
    },
  };
};
